/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. MIT white-label additions to Chatwoot CE.
 */
import axios from 'axios';
import ApiClient from './ApiClient';

class CopilotAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggestReply(conversationId) {
    return axios.post(`${this.url}/${conversationId}/copilot/suggest_reply`);
  }

  summarize(conversationId) {
    return axios.post(`${this.url}/${conversationId}/copilot/summarize`);
  }

  sendDocument(conversationId, botDocumentId) {
    return axios.post(`${this.url}/${conversationId}/copilot/send_document`, {
      bot_document_id: botDocumentId,
    });
  }
}

export default new CopilotAPI();
